import React, { Component } from 'react';
import {
  BackHandler,
  ImageBackground,
  NativeModules,
  StyleSheet,
  Text,
  View,
  Dimensions,
} from 'react-native';
import { translate } from 'react-i18next';
import progressActor from '../assets/images/progress-actor-full.jpg';
import Theme from '../theme';
import { LoadingModal } from '../ui';
import { ConnectingLoaderIcon } from '../ui/components/Icons';
import { defaultScale } from '../utils/scaling';
import { Logger } from '../utils/Logger';
const { width } = Dimensions.get('window');

class EliteUpdateScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageLoaded: false,
      installState: 'starting',
    };
  }

  componentDidMount = async () => {
    BackHandler.addEventListener('hardwareBackPress', this.ignoreBackButton);
    await this.installUpdatesNow('installing updates from EliteUpdateScreen');
  }

  installUpdatesNow = async (details) => {
    const { installState } = this.state;
    this.setState({ installState: 'installing' });

    try {
      // todo: also change the wording of installing when downloading in the background
      Logger.leaveBreadcrumb('installing updates', {
        details,
        installState,
      });
      const info = await NativeModules.EliteUpdate.install();
      // todo: handle successful installs of other packages here
      //  when fitilltion is updates, the app gets killed before this
      //  so nothing is needed here
      //  but after updating other apps, we need to navigate here
      Logger.debug('[EliteUpdateScreen] install result', info);

      if (info && info.result === 'prepared') {
        this.setState({ installState: 'prepared' });
      }
    } catch (e) {
      Logger.notify(e);
      this.props.navigation.navigate('Loading', { skipUpdate: true });
    }
  }

  componentWillUnmount = () => {
    BackHandler.removeEventListener('hardwareBackPress', this.ignoreBackButton);
  }

  ignoreBackButton = () => true;

  render() {
    const { t } = this.props;
    const { imageLoaded, installState } = this.state;

    if (installState === 'prepared') {
      this.installUpdatesNow('installing updates after prepared from EliteUpdateScreen.render');
    }

    return (
      <View style={styles.root}>
        <ImageBackground
          source={progressActor}
          style={styles.imageStyle}
          resizeMode='cover'
          onLoad={() => { this.setState({ imageLoaded: true}); }}
        ></ImageBackground>

        {imageLoaded && (
          <View style={styles.loadingContainer}>
            <View style={styles.loadingIcon}>
              <ConnectingLoaderIcon
                useClockwiseSquareSvg
                width={defaultScale(60)}
                height={defaultScale(60)}
                animating={true}
                color={Theme.BLACK}
              />
            </View>

            <Text style={styles.descriptionText}>
              {t('installing')}
            </Text>
          </View>
        )}

        {!imageLoaded && (
          <View style={styles.placeholder}>
            <LoadingModal isLoading={true} />
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  root: {
    width,
    height: '100%',
    backgroundColor: Theme.WHITE,
  },
  placeholder: {
    flex: 1,
    justifyContent: 'center',
    minHeight: '100%',
  },
  imageStyle: {
    flex: 3,
    width,
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingIcon: {
    paddingVertical: defaultScale(20),
  },
  descriptionText: {
    ...Theme.textStyle.heading,
    textAlign: 'center',
    paddingVertical: defaultScale(10),
  },
});

export default translate(['elite'], { wait: true })(EliteUpdateScreen);
